// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c39dd61b","952":"85c1790c"}[chunkId] + ".chunk.js";
};